import React from 'react';
import { Modal, Form, Input, Upload, Select, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const { Option } = Select;

interface TaskModalProps {
  open: boolean;
  loading: boolean;
  projects: string[];
  templates: any[];
  selectedProject: string;
  form: any; // 接收外部传递的form实例
  onSubmit: () => void;
  onCancel: () => void;
  onProjectChange: (value: string) => void;
}

const TaskModal: React.FC<TaskModalProps> = ({
  open,
  loading,
  projects,
  templates,
  selectedProject,
  form,
  onSubmit,
  onCancel,
  onProjectChange
}) => {
  const handleOk = async () => {
    try {
      await form.validateFields();
      onSubmit();
    } catch (error) {
      console.log('表单校验失败:', error);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      title="新建文本标签识别任务"
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={loading}
      destroyOnHidden
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Form.Item
          name="file"
          label={<span>上传文件 <span style={{ color: '#999', fontSize: 12, marginLeft: 4 }}>支持excel或者csv文件格式</span></span>}
          valuePropName="fileList"
          getValueFromEvent={e => (Array.isArray(e) ? e : e && e.fileList)}
          rules={[{ required: true, message: '请上传CSV或Excel文件' }]}
        >
          <Upload beforeUpload={() => false} maxCount={1} accept=".csv,.xls,.xlsx">
            <Button icon={<UploadOutlined />}>选择文件</Button>
          </Upload>
        </Form.Item>
        <Form.Item
          name="project_name"
          label="选择项目"
          rules={[{ required: true, message: '请选择项目' }]}
        >
          <Select
            placeholder="请选择项目"
            onChange={(value) => {
              onProjectChange(value);
              form.setFieldsValue({ template_name: undefined });
            }}
          >
            {projects.map(project => (
              <Option key={project} value={project}>{project}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name="template_name"
          label="选择模板"
          rules={[{ required: true, message: '请选择模板' }]}
        >
          <Select
            placeholder="请选择模板"
            disabled={!selectedProject}
          >
            {templates
              .filter(template => template.project_name === selectedProject)
              .map(template => (
                <Option key={template.template_name} value={template.template_name}>
                  {template.template_name}
                </Option>
              ))
            }
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default TaskModal;
